<template>
  <div class="min-h-[18rem] sm:min-h-[auto] md:h-60 lg:h-[17.5rem] 4xl:h-[14.75rem]
              flex md:flex-row
              pr-6 xs:pr-12 md:px-2 md:pr-12 lg:pr-6  3xl:pr-12 4xl:mr-1
              rounded-xl bg-pastel-blue-lighter">
    <div class="hidden sm:flex
                mx-6 xl:mt-auto 4xl:mt-0">
      <img class="block mt-auto 2xl:mx-auto
                  min-w-[12.625rem] lg:min-w-[13rem]"
           src="@/assets/images/man_with_hands.svg" />
    </div>
    <div class="flex flex-col xl:flex-grow pl-4 sm:pl-0 py-6 font-roboto text-xl">
      <div class="font-bold sm:text-base 4xl:text-lg">
        Talkatoo Dictation Tip #{{ index + 1 }}:<br />
        {{ tip.title }}
      </div>
      <div class="text-main-darker font-normal mt-4  text-sm 4xl:text-base"
           v-html="tip.content">
      </div>
      <div class="block mt-auto">
        <button class=" text-main-alt text-xl sm:text-sm font-bold italic underline"
                @click="nextTip">
          View another tip
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    const storedIndex = localStorage.getItem('tipIndex');
    return {
      index: storedIndex === null ? 0 : parseInt(storedIndex),
      tips: [
        {
          title: "Select the correct microphone",
          content:
            `For best dictation results, a good quality microphone will make <br class="hidden 5xl:block"/>
             all the difference. Make sure you've selected this model within <br class="hidden 5xl:block"/>
             the Talkatoo settings window when setting up.`
        }, {
          title: "Setting your microphone level ",
          content: `For louder environments set the microphone level to 25-35%; for quieter ones, go to 40-50%.`
        }, {
          title: "How to hold your microphone",
          content: `When using your dictation microphone, make sure to hold it two inches from your mouth.`
        }, {
          title: "Starting and stopping dictation",
          content:
            `To start dictating, press the dictation button and release, then begin speaking.<br class="hidden 5xl:block"/>
             Wait for the last word to come up on the screen before pressing the <br class="hidden 5xl:block"/>
             button again to end dictation.`
        }, {
          title: "Special voice commands",
          content:
            `While dictating, say the words “new line” when you want your <br class="hidden 5xl:block"/>
             cursor to move to the next line, and “new paragraph” when you <br class="hidden 5xl:block"/>
             want the cursor to create a new paragraph. `
        }, {
          title: "Don’t look at the screen",
          content: `Instead, focus on your notes and the software will capture everything you need.`
        }, {
          title: "How to dictate short-form measurements",
          content:
            `Add the measurements you use most often to ‘my words’ (e.g., ml, kg, mg, lbs)<br class="hidden 5xl:block"/>
             and speak them phonetically while dictating: <br class="hidden 5xl:block"/>
             “Buster has lost five  ‘el bee ess’ since his last visit.”`
        }, {
          title: "Proper pronunciation is key",
          content:
            `If a word is not being recognized properly, search for the phonetic pronunciation. <br class="hidden 5xl:block"/>
             Sometimes small changes in how the word is spoken can improve accuracy.  <br class="hidden 5xl:block"/>
             As an example: Tachypnea is pronounced ta·kuhp·nee·uh. <br class="hidden 5xl:block"/>`
        }, {
          title: "My words",
          content:
            `Sometimes something you say will be misheard as  another popular <br class="hidden 5xl:block"/>
             word or spelling. This can be easily solved by defining which you prefer<br class="hidden 5xl:block"/>
             and adding it in ‘my words’ (e.g., Sean, Shaun, or Shawn). `
        }, {
          title: "More is better",
          content:
            `Talkatoo does its best work with more context, so try to speak naturally; <br class="hidden 5xl:block"/>
             in full thoughts and sentences whenever possible.`
        },
      ]
    };
  },
  computed: {
    tip () {
      return this.tips[this.index];
    }
  },
  methods: {
    nextTip () {
      this.index++;
      if (this.index == this.tips.length)
        this.index = 0;
      localStorage.setItem('tipIndex', this.index.toString());
    },
  }
};
</script>

<style>
</style>